import {inject, Injectable} from "@angular/core";
import {OAuthStatusTypes} from "@trumpf/ux.utils";
import {LoginResponse, OidcSecurityService} from "angular-auth-oidc-client";
import {BehaviorSubject, Observable} from "rxjs";
import {AuthStatusInterface, UserInterface} from "../../../interfaces";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  public authStatus$: BehaviorSubject<AuthStatusInterface>;
  public user$: BehaviorSubject<UserInterface | null>;
  private _authenticated = false;

  constructor() {
    this.user$ = new BehaviorSubject<UserInterface | null>(null);
    this.authStatus$ = new BehaviorSubject<AuthStatusInterface>({
      status: OAuthStatusTypes.ERROR,
      error: null,
      accessToken: null
    });

    this.oidcSecurityService.getUserData().subscribe(userData => {
      if (userData && Object.keys(userData).length > 0) {
        this.user$.next({
          userName: userData?.windowsAccountName ?? null,
          displayName: `${userData?.given_name ?? ""} ${userData?.family_name ?? ""}`.trim() ?? null,
          groups: userData?.groups || []
        });
      }
    });
  }

  public getAccessToken(): Observable<string> {
    return this.oidcSecurityService.getAccessToken();
  }

  public isAuthenticated(): boolean {
    return this._authenticated;
  }

  public checkAuth(): Observable<LoginResponse> {
    const observable = this.oidcSecurityService.checkAuth();

    observable.subscribe(({isAuthenticated, accessToken}) => {
      // console.log('app authenticated', isAuthenticated);
      // console.log(`Current access token is '${accessToken}'`);

      this.authStatus$.next({
        status: OAuthStatusTypes.AUTHENTICATED,
        error: null,
        accessToken: accessToken
      });

      this._authenticated = isAuthenticated;

      // if (isAuthenticated) {
      //   getAuthClient().setAccessToken(accessToken);
      //
      //   this.authStatus$.next({
      //     status: OAuthStatusTypes.AUTHENTICATED,
      //     error: null,
      //     accessToken: accessToken
      //   });
      //
      //   this._authenticated = true;
      // } else {
      //   getAuthClient().setAccessToken(undefined);
      //
      //   this.authStatus$.next({
      //     status: OAuthStatusTypes.ERROR,
      //     error: null,
      //     accessToken: null
      //   });
      //
      //   this._authenticated = false;
      // }
    });

    return observable;
  }

  public authorize(): void {
    this.oidcSecurityService.authorize();
  }

  public logout(): void {
    this.oidcSecurityService.logoff().subscribe();
  }

  public getUserName(): string | null {
    return this.user$.value?.userName || null;
  }

  public getUserDisplayName(): string | null {
    return this.user$.value?.displayName || null;
  }
}
